/**
 * Propensity score (0–100) rendered as 🔥 flames — 1 to 5, in 20-point bands:
 *   0–20 → 🔥   21–40 → 🔥🔥   41–60 → 🔥🔥🔥   61–80 → 🔥🔥🔥🔥   81–100 → 🔥🔥🔥🔥🔥
 *
 * A real score of 0 still earns one flame; only a missing score (null) is N/A —
 * the caller handles the null case (no flames).
 */
export function propensityFireCount(score: number): number {
  if (score <= 20) return 1;
  if (score <= 40) return 2;
  if (score <= 60) return 3;
  if (score <= 80) return 4;
  return 5;
}

export function propensityFire(score: number): string {
  return '🔥'.repeat(propensityFireCount(score));
}
